// spec 260509-system-monitor C-4：④ 段服务汇总。
//
// 不展开服务列表，只渲染：
//   - "正常 N / 总 M" 数字
//   - ≥1 个异常 → 显示第一个异常服务的 display_name；点击 ④ 段定位到该卡的
//     anchor（``#services-{name}``）。
//   - 无异常 → 整段链到 ``#services``。
//
// 异常判定与 dashboard ServiceCardItem 一致：``estimated_unhealthy_for_seconds
// ≥ 10`` ∨ lifecycle=down/restarting ∨ status=failed/unavailable。

import type { MouseEvent, ReactElement } from 'react';

import { isServiceUnhealthy } from '../../ServiceCardItem';
import { useSystemMetricsStore } from '../../state/system-metrics-store';
import { useHideHealthErrors } from '../hideErrorsFlag';
import { navigateToDashboard } from '../navigateToDashboard';

export function ServicesSummarySection(): ReactElement {
  const services = useSystemMetricsStore((s) => s.services);

  // 后端 HIDE_HEALTH_ERRORS=1 时把异常视为空，统一走 OK 分支；
  // 否则按真实判定。dashboard ④ 段不受影响。
  const hide = useHideHealthErrors();
  const total = services.length;
  const unhealthy = hide ? [] : services.filter(isServiceUnhealthy);
  const healthy = total - unhealthy.length;
  const firstBad = unhealthy[0] ?? null;

  const sev: 'ok' | 'warn' | 'crit' =
    unhealthy.length === 0
      ? 'ok'
      : unhealthy.some((s) => s.tier === 'critical')
        ? 'crit'
        : 'warn';

  const anchor = firstBad ? `#services-${firstBad.name}` : '#services';
  const anchorBare = firstBad ? `services-${firstBad.name}` : 'services';
  const onClick = (e: MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    navigateToDashboard(anchorBare);
  };

  return (
    <a
      className={`sysmon-section sysmon-services sysmon-services-${sev}`}
      data-section="services"
      data-severity={sev}
      data-services-anchor={anchor}
      href={anchor}
      onClick={onClick}
      aria-label={`服务 ${healthy}/${total}`}
    >
      <span className="sysmon-services-counts">
        {healthy} / {total}
      </span>
      {firstBad ? (
        <span className="sysmon-services-fail">
          {firstBad.display_name ?? firstBad.name} {firstBad.lifecycle_state ?? firstBad.status}
        </span>
      ) : (
        <span className="sysmon-services-ok">全部正常</span>
      )}
    </a>
  );
}

export default ServicesSummarySection;
